"use client"

import { getPostFields, pickPostImageFormat } from "@/(admin)/modules/ui-builder/config/lib/post-helpers"
import { getLocalizedHref } from "@/lib/locale-utils"
import { toImageSrc } from "@/lib/utils"
import { FeaturedPostClassNameProps, PostData } from "@/types/types"
import Image from "next/image"
import Link from "next/link"
import { twMerge } from "tailwind-merge"

export default function FeaturedPost({
  post,
  className,
  contentClassName,
  imageClassName,
  titleClassName,
  descriptionClassName,
  dateClassName,
  isVideo = false,
  youtubeUrl,
  onVideoClick,
}: {
  post: PostData
} & FeaturedPostClassNameProps) {
  const { postTitle, description, postSlug, formattedPublishedAt } = getPostFields(post)
  // Slug thuộc locale nào thì URL theo locale đó → lấy thẳng từ chính bài.
  const locale = post.attributes.locale

  const handleClick = (e: React.MouseEvent) => {
    if (isVideo && youtubeUrl && onVideoClick) {
      e.preventDefault()
      onVideoClick(youtubeUrl)
    }
  }

  return (
    <Link
      href={isVideo && youtubeUrl ? "#" : getLocalizedHref(locale, `/${postSlug}`)}
      onClick={handleClick}
      className={twMerge("image-hover flex w-full", className, isVideo && youtubeUrl ? "cursor-pointer" : "")}
    >
      <div className={twMerge("sm:w-2/3 relative w-full h-full", imageClassName)}>
        <Image
          src={toImageSrc(pickPostImageFormat(post, "large") ?? undefined)}
          alt={postTitle}
          priority
          fetchPriority="high"
          fill
          sizes="(max-width: 640px) 100vw, 66vw"
          className="object-cover"
        />
      </div>
      <div
        className={twMerge(
          "py-6 flex flex-col gap-1 px-[22px] bg-[#f5f5f5] group-hover:bg-transparent sm:w-1/3 w-full",
          contentClassName,
        )}
      >
        <h2 className={twMerge("text-lg leading-[22.4px] font-bold", titleClassName)}>{postTitle}</h2>
        {!isVideo && description && (
          <div
            className={twMerge("text-base leading-[24.8px] text-[#4F4F4F] line-clamp-6", descriptionClassName)}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <p className={twMerge("text-sm font-normal leading-[21.7px] text-black group-hover:text-black", dateClassName)}>
          {formattedPublishedAt}
        </p>
      </div>
    </Link>
  )
}
